export default function ProductOrderDetail({
  products,
  handleClick,
  ...props
}) {
  const redStrikethrough = {
    textDecoration: "line-through",
    textDecorationColor: "red",
    textDecorationThickness: "1px",
  };

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = "/images/img-default.jpeg";
  };

  return (
    <div>
      {products &&
        products.map((item, index) => (
          <li className="px-2" key={item.id} onClick={() => handleClick(item)}>
            <div className="row gx-2 align-items-center">
              <div className="col-7 d-flex align-items-center">
                <img
                  src={item.productImage}
                  className="foodimg"
                  alt={item.productName}
                  onError={handleImageError}
                />
                <div
                  className="fs-12"
                  style={
                    item.isCancel || item.productStatus === 4
                      ? redStrikethrough
                      : {}
                  }
                >
                  {item.productName}
                </div>
              </div>
              <div
                className={`col-2 fs-14 text-center foodQtyli  ${
                  item.productStatus === 4 ? "line-through" : ""
                } ${item.prevUnit ? "text-[var(--color-red)]" : ""} relative`}
              >
                <div className="text-nowrap">{item.productQty}</div>
                {item.prevUnit && (
                  <div className="absolute line-through top-[calc(min(0.78vw,8px)*-1)] right-[calc(min(0.2vw,1px)*-1)] text-12 text-black">
                    {item.prevUnit}
                  </div>
                )}
              </div>
              <div className="col-3 fs-14 text-end relative">
                <span
                  className={`foodPriceli ${
                    item.prevPrice ? "text-[var(--color-red)]" : ""
                  }`}
                  style={
                    item.isCancel || item.productStatus === 4
                      ? redStrikethrough
                      : {}
                  }
                >
                  {item.displayPrice || item.productPrice}
                </span>
                .-
                {item.prevPrice && (
                  <div className="absolute line-through top-[calc(min(0.78vw,8px)*-1)] right-[calc(min(0.2vw,1px)*-1)] text-12 text-black">
                    {item.prevPrice}.-
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex flex-wrap bx-Foption ">
              {item.standardOptions &&
                item.standardOptions.map((item2, index) => (
                  <div
                    className="Foption mb-0  mt-2"
                    key={item2.listID || `standard-${index}`}
                  >
                    {item2.itemName}
                  </div>
                ))}
              {item.specificOptions &&
                item.specificOptions.map((item2, index) => (
                  <div
                    className="Foption mb-0 mt-2"
                    key={item2.listID || `specific-${index}`}
                  >
                    {item2.itemName}
                  </div>
                ))}
            </div>
            <div>
              {(() => {
                const annotationTexts =
                  item.annotationOptions && item.annotationOptions.length > 0
                    ? item.annotationOptions.map((item2) => item2.itemName)
                    : [];

                if (item.note && item.note.trim() !== "") {
                  annotationTexts.push(item.note.trim());
                }

                if (annotationTexts.filter((e) => e !== undefined).length > 0) {
                  return annotationTexts.length > 0 ? (
                    <div className="fNote mt-2 m-1">
                      {annotationTexts.join(", ")}
                    </div>
                  ) : (
                    ""
                  );
                }
              })()}
            </div>
            <div className="flex items-center absolute right-1 bottom-1 text-[#C9BEBE] text-xs font-normal font-sarabun">
              <CheckIcon
                color={
                  item.productStatus === 1
                    ? `#E4DFDF`
                    : item.productStatus === 2
                    ? `#00FF00`
                    : item.productStatus === 3
                    ? `#FF0000`
                    : item.productStatus === 4
                    ? "#FF0000"
                    : item.productStatus === 0
                    ? ""
                    : "#E4DFDF"
                }
              />
              <span
                style={{
                  color:
                    item.productStatus === 1
                      ? "#E4DFDF"
                      : item.productStatus === 2
                      ? "#00FF00"
                      : item.productStatus === 3
                      ? "#FF0000"
                      : item.productStatus === 4
                      ? "#FF0000"
                      : item.productStatus === 0
                      ? ""
                      : "#E4DFDF",
                }}
                className=""
              >
                {item.productStatus === 4
                  ? "ยกเลิก"
                  : item.productStatus === 0
                  ? ""
                  : "สั่งแล้ว"}
              </span>
            </div>
          </li>
        ))}
    </div>
  );
}

const CheckIcon = ({ color = "#FF0000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    className="mr-1"
  >
    <path
      d="M9.8539 3.14598C9.90046 3.19242 9.93741 3.2476 9.96261 3.30834C9.98782 3.36909 10.0008 3.43421 10.0008 3.49998C10.0008 3.56575 9.98782 3.63087 9.96261 3.69161C9.93741 3.75236 9.90046 3.80753 9.8539 3.85398L5.3539 8.35398C5.30745 8.40054 5.25228 8.43748 5.19153 8.46269C5.13079 8.4879 5.06567 8.50087 4.9999 8.50087C4.93413 8.50087 4.86901 8.4879 4.80827 8.46269C4.74752 8.43748 4.69234 8.40054 4.6459 8.35398L2.6459 6.35398C2.55201 6.26009 2.49927 6.13275 2.49927 5.99998C2.49927 5.8672 2.55201 5.73986 2.6459 5.64598C2.73979 5.55209 2.86712 5.49935 2.9999 5.49935C3.13267 5.49935 3.26001 5.55209 3.3539 5.64598L4.9999 7.29298L9.1459 3.14598C9.19235 3.09941 9.24752 3.06247 9.30827 3.03727C9.36901 3.01206 9.43413 2.99908 9.4999 2.99908C9.56567 2.99908 9.63079 3.01206 9.69153 3.03727C9.75228 3.06247 9.80745 3.09941 9.8539 3.14598Z"
      fill={color}
    />
  </svg>
);
